'use client';
import { jsx } from 'react/jsx-runtime';
import { Close } from '../../../../node_modules/@radix-ui/react-dialog/dist/index.js';
import classnames from '../../../../node_modules/classnames/index.js';
import { useLocalization } from '../../../ConstellationProvider/ConstellationProvider.hooks.js';
import * as index from '../../localization/index.js';
import modules_0ddd42df from './CloseButton.module.scss.js';
import cross16 from '../../../../packages/constellation-components/node_modules/@trustpilot/icons/lib/cross_16.svg.js';
import { Button } from '../../../Button/Button.js';

const CloseButton = ({ className }) => {
    const { strings } = useLocalization(index);
    return (jsx(Close, { asChild: true, children: jsx(Button, { ariaLabel: strings.close, appearance: "outline", className: classnames(modules_0ddd42df.button, className), icon: cross16, size: "s" }) }));
};

export { CloseButton };
//# sourceMappingURL=CloseButton.js.map
